import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Grid } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";

export default function ContentPanel({children, header, ...props}) {
    return (
        <Panel header={header} className="content-panel table-panel full">
            {children}
        </Panel>
    )
}